"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMacroInfoResponse = void 0;

var _lodash = require("lodash");

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _modelBuilders = require("../../../../utils/model-builders");

var _BooleanAsNumber = require("../../../../types/BooleanAsNumber");

var _DataServerDate = require("../../../../types/DataServerDate");

function GenericObject(data) {
  return data;
}

var numberParameter = {
  min: {
    type: Number,
    path: 'ParameterAttribute[0].Min[0]'
  },
  max: {
    type: Number,
    path: 'ParameterAttribute[0].Max[0]'
  },
  step: {
    type: Number,
    path: 'ParameterAttribute[0].Step[0]'
  }
};
var listParameter = {
  value: {
    type: Number,
    path: '$.Value'
  },
  description: {
    type: String,
    path: '$.Description'
  }
};
var aafParameterType = [{
  name: 'eInteger',
  constructor: Number,
  model: numberParameter
}, {
  name: 'eDouble',
  constructor: Number,
  model: numberParameter
}, {
  name: 'eString',
  constructor: String,
  model: String
}, {
  name: 'eBool',
  constructor: _BooleanAsNumber.BooleanAsNumber,
  model: Boolean
}, {
  name: 'eList',
  constructor: Number,
  model: listParameter,
  path: 'ParameterAttribute[0].List[0].Item'
}, {
  name: 'eMultiSelList',
  constructor: GenericObject,
  model: listParameter,
  path: 'ParameterAttribute[0].List[0].Item'
}, {
  name: 'eDynamicList',
  constructor: GenericObject,
  model: listParameter,
  path: 'ParameterAttribute[0].List[0].Item'
}];

var parseAlgorithmParameters = function parseAlgorithmParameters(raw) {
  return raw.Parameter.map(function (parameter) {
    var title = (0, _lodash.get)(parameter, '$.Title');
    var description = (0, _lodash.get)(parameter, '$.Description');
    var rawType = (0, _lodash.get)(parameter, '$.Type');
    var rawValue = (0, _lodash.get)(parameter, '$.Value');
    var aafType = aafParameterType[rawType];
    var value = aafType.constructor(rawValue); // default; might be overridden.

    var attributes;

    if (aafType.path) {
      attributes = (0, _modelBuilders.parseModelArray)(parameter, aafType.model, aafType.path); // for some types, "Value" is a reference (for instance, to an item in a list). eDynamicList seems to behave
      // differently; it's a reference to the value of an item. Some "lists" have no values. For now just ignore these
      // outliers. TODO: Understand better.

      value = attributes && attributes[value] ? attributes[value].description : value;
    } else {
      attributes = (0, _modelBuilders.parseModel)(parameter, aafType.model);
    }

    return {
      title: title,
      description: description,
      type: aafType.name,
      value: value,
      attributes: attributes
    };
  });
};

var createMacroInfoResponse = function createMacroInfoResponse(raw) {
  return (0, _modelBuilders.parseModel)(raw, {
    result: {
      model: _genericAsResultHeader.genericAsResultHeader,
      path: 'GetMacroInfo2Result[0]'
    },
    response: {
      path: 'MacroInfo[0]',
      model: {
        id: {
          type: Number,
          path: '$.Id'
        },
        name: {
          type: String,
          path: '$.Name'
        },
        isDeleted: {
          type: _BooleanAsNumber.BooleanAsNumber,
          path: '$.MacroMarkedDeleted'
        },
        dataGroupName: {
          type: String,
          path: '$.DataGroupName'
        },
        createdBy: {
          type: String,
          path: '$.FullName'
        },
        version: {
          type: Number,
          path: '$.Version'
        },
        createdOn: {
          type: _DataServerDate.DataServerDate,
          path: '$.CreatedOn'
        },
        algorithms: {
          path: 'Algorithms[0].Algorithm',
          model: {
            name: {
              type: String,
              path: '$.Name'
            },
            description: {
              type: String,
              path: '$.Description'
            },
            sequenceOrder: {
              type: Number,
              path: '$.SequenceOrder'
            },
            isIncremental: {
              type: _BooleanAsNumber.BooleanAsNumber,
              path: '$.Incremental'
            },
            licenseId: {
              type: Number,
              path: '$.AlgorithmLicenseId'
            },
            parameters: parseAlgorithmParameters,
            macroOutputs: {
              path: 'MacroOutputCollection[0].MacroOutput',
              model: {
                id: {
                  type: Number,
                  path: 'Id'
                },
                title: {
                  type: String,
                  path: 'Title'
                },
                macroAlgorithmId: {
                  type: Number,
                  path: 'MacroAlgorithmId'
                },
                rowState: {
                  type: String,
                  path: 'RowState'
                },
                isIvd: {
                  type: Boolean,
                  path: 'IsIvd[0].$.p3:nil'
                }
              }
            }
          }
        }
      }
    }
  });
};

exports.createMacroInfoResponse = createMacroInfoResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/macros/response-parsers/macro-info-response.js
// module id = 230
// module chunks = 0